module.exports = __webpack_public_path__ + "static/media/animal_music_band_singer.4a8bf5f6.png";